import * as z from "zod/v4";

export const investmentListingStatusSchema = z.enum([
	"Draft",
	"Active",
	"Under Contract",
	"Closed",
	"Withdrawn",
	"Expired"
]);

export type InvestmentListingStatus = z.infer<typeof investmentListingStatusSchema>;

export const PUBLIC_INVESTMENT_LISTING_STATUSES: readonly InvestmentListingStatus[] = [
	"Active",
	"Under Contract"
];

export const publicInvestmentListingMediaSchema = z.object({
	id: z.uuid(),
	publicUrl: z.string(),
	cardUrl: z.string(),
	emailUrl: z.string(),
	galleryUrl: z.string(),
	isFeatured: z.boolean(),
	orderIndex: z.number()
});

export type PublicInvestmentListingMedia = z.infer<typeof publicInvestmentListingMediaSchema>;

export const publicInvestmentListingSchema = z.object({
	id: z.uuid(),
	slug: z.string(),
	status: z.string(),
	propertyType: z.string(),
	propertySubType: z.string(),
	description: z.string(),
	currentPrice: z.number(),
	addressStreet1: z.string(),
	addressStreet2: z.string().nullable(),
	addressCity: z.string(),
	addressState: z.string(),
	addressZip: z.string(),
	bedrooms: z.number(),
	fullBathrooms: z.number(),
	halfBathrooms: z.number(),
	totalBathrooms: z.number(),
	livingArea: z.number(),
	lotSize: z.number(),
	lotSizeUnit: z.enum(["Acres", "Square Feet"]),
	yearBuilt: z.number(),
	parkingSpaces: z.number(),
	interiorFeatures: z.array(z.string()).nullable(),
	exteriorFeatures: z.array(z.string()).nullable(),
	virtualTourUrl: z.string().nullable(),
	updatedAt: z.string(),
	media: z.array(publicInvestmentListingMediaSchema)
});

export type PublicInvestmentListing = z.infer<typeof publicInvestmentListingSchema>;

export const investmentListingMapPinSchema = z.object({
	id: z.string(),
	latitude: z.number(),
	longitude: z.number(),
	currentPrice: z.number().nullable(),
	status: z.string(),
	beds: z.number().nullable(),
	baths: z.number().nullable(),
	livingArea: z.number().nullable(),
	addressStreet1: z.string().nullable(),
	addressCity: z.string().nullable(),
	addressState: z.string().nullable(),
	addressZip: z.string().nullable(),
	virtualTourUrl: z.string().nullable(),
	media: z.array(z.object({ publicUrl: z.string(), thumbnailUrl: z.string() }))
});

export type InvestmentListingMapPin = z.infer<typeof investmentListingMapPinSchema>;
